export default __webpack_public_path__ + "static/media/3.78f17208.png";